import React, { useState } from 'react';
import { Card, Box, CardMedia } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IContestSummary } from '../../redux/activity/types';

import { UserGroup } from '../UserGroup/UserGroup';
import { OnHoverAnimator } from '../OnHoverAnimator/OnHoverAnimator';
import { useDispatch } from 'react-redux';
import { navigate } from '../../redux/navigator/action';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { ROUTES } from '../../types/global/routes.types';
import { HostOrBrandAvatar } from '../Avatar/HostOrBrandAvatar';

export interface IContestSuggestionCard {
    contests: IContestSummary;
}

const ContestSuggestionCard: React.FC<IContestSuggestionCard> = ({ contests }) => {
    const { themeStyle, device } = useThemeContext();
    const { submissions, total_submissions, host } = contests;
    const [isHovered, setIsHovered] = useState(false);
    const dispatch = useDispatch();

    const handleGoToCampaign = () => {
        let route = replaceRouteParam(ROUTES.ESVIEW_CONTEST, 'contestId', contests.slug!);
        dispatch(
            navigate({
                routes: route,
            }),
        );
    };

    return (
        <Card
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleGoToCampaign}
            sx={{
                width: '100%',
                borderRadius: 2,
                mt: 2,
                backgroundColor: theme[themeStyle].secondaryBg,
                height: '100px',
                position: 'relative',
            }}>
            {device.isDesktop && (
                <OnHoverAnimator
                    onActionPress={handleGoToCampaign}
                    isHovered={isHovered}
                    title="Join Campaign"
                    sxContainer={{ marginTop: '15%' }}
                />
            )}

            <CardMedia
                component="img"
                image={contests.feature_image}
                alt="Event"
                sx={{ height: '100px', width: '100%' }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    left: 10,
                    bottom: 10,
                }}>
                <UserGroup
                    userCount={total_submissions}
                    users={submissions.map(sub => sub.created_by)}
                    label="participating"
                    maxAvatarDisplay={3}
                    labelStyle={{
                        color: theme[themeStyle].true_white,
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        p: 0.3,
                        px: 1,
                        borderRadius: 1,
                        fontSize: 8,
                    }}
                />
            </Box>

            <Box
                sx={{
                    position: 'absolute',
                    right: 10,
                    bottom: 10,
                }}>
                {host && <HostOrBrandAvatar host={host} />}
            </Box>
        </Card>
    );
};

export { ContestSuggestionCard };
